// extracted by mini-css-extract-plugin
module.exports = {"root":"task-page_root__1Hm5t","item":"task-page_item__2tgTM","slider":"task-page_slider__1n8VR","title":"task-page_title__aBMrP","buttons":"task-page_buttons__1JkVZ"};